import { getMyProfile, syncSubscriptions } from '@/api';
import iconCheck from '@/assets/icons/icon-check.png';
import imgPinkfong from '@/assets/images/default/pinkfong.png';
import imgQr from '@/assets/images/default/qr.png';
import { ClientAuth, Device } from '@/classes';
import { QRCodeSVG } from 'qrcode.react';
import { stringify } from 'qs';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

function CheckIcon() {
  return <img src={iconCheck} className="w-[26px] h-[26px] mr-[12px] inline" />;
}

export const EncourageSubscribeBanner = () => {
  const { t } = useTranslation();

  const url = useMemo(() => {
    const language = Device.language === 'ko' ? 'ko' : Device.language === 'ja' ? 'ja' : 'en';
    const pinkfongPlusUrl = `${process.env.REACT_APP_PINKFONG_PLUS_URL}/${language}/membership/select?${stringify({
      utm_source: Device.utm_source,
    })}`;

    if (process.env.NODE_ENV === 'development') {
      console.info('Pinkfong Plus URL', pinkfongPlusUrl);
    }

    return pinkfongPlusUrl;
  }, []);

  const [isSubscribedUser, setIsSubscribedUser] = useState(!!(ClientAuth.user && ClientAuth.user.isSubscriber));

  useEffect(() => {
    const load = async () => {
      if (ClientAuth.user && !ClientAuth.user.isSubscriber) {
        try {
          await syncSubscriptions();

          const user = await getMyProfile();
          ClientAuth.user = user;

          setIsSubscribedUser(user.isSubscriber);
        } catch (e) {
          if (process.env.NODE_ENV === 'development') {
            console.error(e);
          }
        }
      }
    };

    load();
  }, []);

  return (
    <div className={`w-screen h-[600px] bg-[#0F2648] text-white px-[71px] py-[81px] flex justify-between`}>
      <div>
        <p className="text-[60px] font-bold">{ClientAuth.user?.email ?? ''}</p>
        <p className="text-[40px] font-bold mt-1">
          {isSubscribedUser ? (
            <span dangerouslySetInnerHTML={{ __html: t('mypage_menu_status_susbcribed') }} />
          ) : (
            t('mypage_menu_status_unsusbcribed')
          )}
        </p>
        <button className="rounded-full font-bold text-black py-[4px] px-[25px] bg-secondary text-[26px] mt-12">
          {isSubscribedUser ? t('mypage_menu_benefits_susbcribed') : t('mypage_menu_benefits_unsusbcribed')}
        </button>
        <p className="flex items-center text-[26px] font-bold mt-4">
          <CheckIcon /> {t('mypage_menu_benefits_01')}
        </p>
        <p className="flex items-center text-[26px] font-bold mt-2">
          <CheckIcon /> {t('mypage_menu_benefits_02')}
        </p>
        <p className="flex items-center text-[26px] font-bold mt-2">
          <CheckIcon /> {t('mypage_menu_benefits_03')}
        </p>
        <p className="flex items-center text-[26px] font-bold mt-2">
          <CheckIcon /> {t('mypage_menu_benefits_04')}
        </p>
      </div>
      <div className="flex justify-center items-center mr-[150px] flex-col relative">
        {isSubscribedUser ? (
          <img src={imgPinkfong} />
        ) : (
          <>
            <img src={imgQr} />
            <QRCodeSVG
              style={{ zIndex: 1, position: 'absolute', top: '36px' }}
              value={url}
              width="320px"
              height="320px"
            />
            <p className="mt-2 text-[26px]">{t('mypage_scan_to_subscribe')}</p>
          </>
        )}
      </div>
    </div>
  );
};
